import { IEquipmentHistory } from './IEquipmentHistory';

export interface IFormattedEquipmentHistory extends IEquipmentHistory {
  initialCountTimeToolTip: string;
  mobilizationInitialCountTimeToolTip: string;
}
